<div class="wrapper">
  <div class="header">
    <div class="logo">
      <img src="../../../../../assets/image/logo.png" alt="">
    </div>
  </div>
  <div class="main">
    <div class="payment-cards">
      <a href="" routerLink="payment-cards" routerLinkActive='active' data-tooltip="Payment cards"
        data-tooltip-location="right">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 508 508" style="enable-background:new 0 0 508 508;" xml:space="preserve">
          <g>
            <g>
              <path d="M293.306,406.5h-40.9c-7.8,0-14.1,6.3-14.1,14.1c0,7.8,6.3,14.1,14.1,14.1h40.9c7.8,0,14.1-6.3,14.1-14.1
                C307.406,412.8,301.106,406.5,293.306,406.5z" />
            </g>
          </g>
          <g>
            <g>
              <path
                d="M495.406,145.6l-133-133c-16.8-16.8-44.1-16.8-60.9,0L80.306,234h-37.3c-23.7,0-43,19.3-43,43v188c0,23.7,19.3,43,43,43
                h304.4c23.7,0,43-19.3,43-43V311.4l104.9-104.9C512.206,189.7,512.206,162.4,495.406,145.6z M321.506,32.6c5.8-5.8,15.2-5.8,21,0
                l23,23L187.206,234h-67.1L321.506,32.6z M28.206,277c0-8.2,6.6-14.8,14.8-14.8h304.4c8.2,0,14.8,6.6,14.8,14.8v32.6h-334V277z
                M362.306,465.1L362.306,465.1c0,8.2-6.6,14.8-14.8,14.8h-304.5c-8.2,0-14.8-6.6-14.8-14.8V337.8h334.1V465.1z M475.506,186.6
                l-85.3,85.3c-2.6-21.3-20.7-37.9-42.7-37.9h-120.3l158.3-158.4l90,90C481.206,171.4,481.206,180.8,475.506,186.6z" />
            </g>
          </g>
        </svg>
      </a>
    </div>
    <div class="history">
      <a href="" routerLink="history" routerLinkActive='active' data-tooltip="History " data-tooltip-location="right">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 448 448" style="enable-background:new 0 0 448 448;" xml:space="preserve">
          <g>
            <g>
              <g>
                <polygon
                  points="234.667,138.667 234.667,245.333 325.973,299.52 341.333,273.6 266.667,229.333 266.667,138.667 			" />
                <path d="M255.893,32C149.76,32,64,117.973,64,224H0l83.093,83.093l1.493,3.093L170.667,224h-64
                  c0-82.453,66.88-149.333,149.333-149.333S405.333,141.547,405.333,224S338.453,373.333,256,373.333
                  c-41.28,0-78.507-16.853-105.493-43.84L120.32,359.68C154.987,394.453,202.88,416,255.893,416C362.027,416,448,330.027,448,224
                  S362.027,32,255.893,32z" />
              </g>
            </g>
          </g>
        </svg>
      </a>


    </div>

    <div class="limits">
      <a href="" routerLink="limits" routerLinkActive='active' data-tooltip="Limits" data-tooltip-location="right">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 94.667 94.667" style="enable-background:new 0 0 94.667 94.667;"
          xml:space="preserve">
          <g>
            <g>
              <path d="M82.413,9.146h9.346V83.33h-9.346V9.146z M63.803,11.831l-1.294,0.402c-1.62,0.512-3.524-0.201-4.179-1.558
                c-0.314-0.657-0.329-1.383-0.041-2.047c0.334-0.768,1.044-1.369,1.945-1.65l14.591-4.545l1.776,13.001
                c0.1,0.662-0.086,1.338-0.525,1.898c-0.537,0.688-1.4,1.134-2.368,1.226c-0.116,0.012-0.246,0.018-0.371,0.018
                c-1.651,0-3.053-1.052-3.261-2.444l-0.225-1.967C52.988,37.514,14.157,62.539,12.472,63.617c-0.572,0.366-1.256,0.561-1.98,0.561
                c-0.976,0-1.894-0.36-2.517-0.991c-0.573-0.577-0.841-1.313-0.758-2.069c0.087-0.785,0.558-1.507,1.294-1.975
                C8.906,58.889,47.367,34.026,63.803,11.831z M74.859,25.623v57.705h-9.344V25.623H74.859z M58.518,42.77v40.56h-9.347V42.77
                H58.518z M41.617,60.583v22.744h-9.345V60.583H41.617z M23.75,69.494v13.834h-9.344V69.494H23.75z M94.666,92.234H0V85.3h94.667
                L94.666,92.234L94.666,92.234z" />
            </g>
          </g>
        </svg>
      </a>


    </div>
    <div class="club-cards">
      <a href="" routerLink="discount-cards" routerLinkActive='active' data-tooltip="Club Cards"
        data-tooltip-location="right">
        <svg id="Capa_1" enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg">
          <g>
            <g>
              <path
                d="m509.407 208.74c-3.389-8.006-9.693-14.212-17.751-17.476l-9-3.646v-47.551c0-17.947-14.6-32.547-32.547-32.547h-165.176l-94.733-38.377c-3.848-1.56-8.228.297-9.786 4.143-1.559 3.846.296 8.228 4.143 9.786l60.349 24.448h-157.089l15.567-38.429c3.627-8.953 13.862-13.287 22.814-9.66l30.506 12.358c3.85 1.561 8.229-.297 9.786-4.143 1.559-3.846-.297-8.227-4.143-9.786l-30.507-12.358c-16.63-6.738-35.647 1.312-42.386 17.945l-17.853 44.072h-9.711c-17.946 0-32.546 14.6-32.546 32.547v71.767l-26.945 66.517c-3.265 8.057-3.196 16.904.194 24.91 3.389 8.006 9.693 14.212 17.751 17.476l9.001 3.646v47.551c0 17.947 14.6 32.547 32.546 32.547h32.067c4.15 0 7.514-3.364 7.514-7.514s-3.364-7.514-7.514-7.514h-32.067c-9.659 0-17.518-7.858-17.518-17.518v-134.3h98.75c-17.348 13.705-40.493 37.413-50.252 71.574-1.081 3.785 1.043 7.868 4.76 9.161 4.024 1.4 8.523-.941 9.692-5.033 10.136-35.483 37.538-58.858 52.983-69.645v145.76h-36.29c-4.15 0-7.514 3.364-7.514 7.514s3.364 7.514 7.514 7.514h103.052l74.665 30.247c.925.375 1.879.552 2.819.552 2.97 0 5.783-1.773 6.967-4.695 1.559-3.846-.296-8.228-4.143-9.786l-40.281-16.318h157.088l-15.567 38.429c-3.627 8.953-13.866 13.287-22.814 9.66l-50.501-20.458c-3.849-1.559-8.228.297-9.786 4.143-1.559 3.846.296 8.228 4.143 9.786l50.502 20.458c3.99 1.617 8.116 2.382 12.179 2.382 12.869 0 25.085-7.685 30.207-20.327l17.853-44.072h9.711c17.947 0 32.547-14.6 32.547-32.547v-71.767l26.945-66.516c3.263-8.058 3.194-16.904-.195-24.91zm-483.42 98.067c-4.337-1.757-7.73-5.098-9.555-9.406-1.824-4.309-1.861-9.07-.104-13.407l13.016-32.131v56.305zm67.461-112.141c-1.288-3.029-2.213-7.87 4.574-14.911 3.125-3.242 7.084-5.313 11.655-4.623 9.086 1.369 21.081 11.871 33.779 29.57 4.411 6.149 8.252 12.256 11.216 17.255-28.798-2.815-55.73-14.363-61.224-27.291zm66.857 7.848c-11.929-17.917-29.829-39.44-48.38-42.242-9.137-1.38-17.685 1.751-24.723 9.052-5.406 5.607-13.579 17.12-7.586 31.22 3.726 8.768 12.142 16.201 23.088 22.059h-58.331v-82.537c0-9.66 7.859-17.518 17.518-17.518h98.415v79.966zm307.322 169.419c0 9.66-7.859 17.518-17.518 17.518h-274.775v-145.76c15.445 10.787 42.847 34.161 52.983 69.645 1.171 4.1 5.664 6.421 9.692 5.033 3.72-1.282 5.839-5.383 4.76-9.161-9.759-34.161-32.904-57.869-50.252-71.574h275.11zm-286.663-149.977c2.935-4.95 6.736-10.993 11.111-17.103 12.736-17.789 24.77-28.344 33.883-29.72 4.573-.693 8.534 1.381 11.66 4.623 6.787 7.042 5.861 11.883 4.573 14.911-5.494 12.927-32.429 24.475-61.227 27.289zm286.663.648h-234.692c10.945-5.859 19.362-13.292 23.088-22.059 5.993-14.1-2.18-25.613-7.586-31.22-7.039-7.303-15.595-10.431-24.724-9.052-18.55 2.802-36.451 24.325-48.38 42.242v-79.965h274.775c9.659 0 17.518 7.858 17.518 17.518v82.536zm28.045 5.403-13.016 32.131v-56.305l3.358 1.36c4.336 1.757 7.73 5.098 9.553 9.407 1.825 4.308 1.862 9.07.105 13.407z" />
              <path
                d="m384.165 351.927v7.208c0 4.15 3.364 7.514 7.514 7.514 4.151 0 7.514-3.364 7.514-7.514v-7.002c5.664-1.201 9.545-3.776 12.031-6.116 4.904-4.615 7.832-11.58 7.832-18.633 0-5.776-1.799-11.004-5.203-15.121-4.563-5.518-11.728-8.852-21.297-9.908-8.92-.984-10.252-5.581-10.252-8.234 0-1.565.452-9.375 9.374-9.375 5.746 0 8.232 3.427 8.846 4.449 1.127 2.738 3.818 4.668 6.963 4.668 5.662 0 8.928-5.89 6.761-10.85-1.789-3.887-6.714-9.875-15.056-12.256v-7.35c0-4.15-3.364-7.514-7.514-7.514s-7.514 3.364-7.514 7.514v7.33c-5.116 1.47-9.383 4.497-12.378 8.875-4.186 6.117-4.511 12.653-4.511 14.51 0 9.487 6.19 21.248 23.633 23.172 13.119 1.448 13.119 7.727 13.119 10.091 0 2.306-.815 5.536-3.103 7.688-2.177 2.048-5.551 2.951-10.025 2.676-9.482-.578-11.632-6.485-11.846-7.156l-.003.001c-.814-3.279-3.769-5.713-7.3-5.713-5.167 0-8.855 5.308-7.05 10.155.767 2.406 5.073 13.623 19.465 16.891z" />
            </g>
          </g>
        </svg>
      </a>
      <!-- <h6>text</h6> -->
    </div>
    <div class="personal-information">
      <a href="" routerLink="personal-information" routerLinkActive='active' data-tooltip="Personal information"
        data-tooltip-location="right">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
          x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
          <g>
            <g>
              <path d="M437.02,330.98c-27.883-27.882-61.071-48.523-97.281-61.018C378.521,243.251,404,198.548,404,148
                C404,66.393,337.607,0,256,0S108,66.393,108,148c0,50.548,25.479,95.251,64.262,121.962
                c-36.21,12.495-69.398,33.136-97.281,61.018C26.629,379.333,0,443.62,0,512h40c0-119.103,96.897-216,216-216s216,96.897,216,216
                h40C512,443.62,485.371,379.333,437.02,330.98z M256,256c-59.551,0-108-48.448-108-108S196.449,40,256,40
                c59.551,0,108,48.448,108,108S315.551,256,256,256z" />
            </g>
          </g>
        </svg>
      </a>


    </div>
  </div>
  <div class="footer">
    <div class="logout" style="cursor: pointer;" (click)="logout()">
      <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
        <g>
          <g>
            <path d="M255.15,468.625H63.787c-11.737,0-21.262-9.526-21.262-21.262V64.638c0-11.737,9.526-21.262,21.262-21.262H255.15
              c11.758,0,21.262-9.504,21.262-21.262S266.908,0.85,255.15,0.85H63.787C28.619,0.85,0,29.47,0,64.638v382.724
              c0,35.168,28.619,63.787,63.787,63.787H255.15c11.758,0,21.262-9.504,21.262-21.262
              C276.412,478.129,266.908,468.625,255.15,468.625z" />
          </g>
        </g>
        <g>
          <g>
            <path d="M505.664,240.861L376.388,113.286c-8.335-8.25-21.815-8.143-30.065,0.213s-8.165,21.815,0.213,30.065l92.385,91.173
              H191.362c-11.758,0-21.262,9.504-21.262,21.262c0,11.758,9.504,21.263,21.262,21.263h247.559l-92.385,91.173
              c-8.377,8.25-8.441,21.709-0.213,30.065c4.167,4.21,9.653,6.336,15.139,6.336c5.401,0,10.801-2.041,14.926-6.124l129.276-127.575
              c4.04-3.997,6.336-9.441,6.336-15.139C512,250.302,509.725,244.88,505.664,240.861z" />
          </g>
        </g>
      </svg>

    </div>
    <div class="language">
      <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
        x="0px" y="0px" viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
        <path style="fill:#FFB400;" d="M0,387.466c1.077,20.215,17.807,36.277,38.292,36.277h435.359c21.18,0,38.349-17.169,38.349-38.349
          v-73.479H0V387.466z" />
        <path style="fill:#FF4B55;" d="M473.651,88.257H38.292c-20.485,0-37.215,16.062-38.292,36.277v75.552h512v-73.479
          C512,105.427,494.831,88.257,473.651,88.257z" />
        <rect y="200.089" style="fill:#41479B;" width="512" height="111.83" />
      </svg>

    </div>
  </div>
</div>
